/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import { FaUserAlt, FaEnvelope, FaEnvelopeOpen } from 'react-icons/fa'
import 'bootstrap-daterangepicker/daterangepicker.css'

const ReportEngagement = (props): JSX.Element => {
  const { addedProspects, sentEmails, replyData, openData } = props

  return (
    <div className="tour-duty">
      <div className="tour-duty-card black">
        <p className="card-body">ALL TIME ENGAGEMENT</p>
      </div>
      <div className="tour-duty-card">
        <FaUserAlt className="user-icon" />
        <h3>{addedProspects}</h3>
        <p className="card-body">NEW CONTACTS</p>
      </div>
      <div className="tour-duty-card">
        <FaEnvelope className="user-icon" />
        <h3>{sentEmails}</h3>
        <p className="card-body">Emails Sent</p>
      </div>
      <div className="tour-duty-card">
        <FaEnvelope className="user-icon" />
        <h3>{replyData}</h3>
        <p className="card-body">Emails replied</p>
      </div>
      <div className="tour-duty-card">
        <FaEnvelopeOpen className="user-icon" />
        <h3>{openData}</h3>
        <p className="card-body">Emails opened</p>
      </div>
    </div>
  )
}

export default ReportEngagement
